  $(document).ready(function() {
    $('.search-modal-link').click(function(){
      $('.search-field ').focus();
    });
    
    var retriesMiniCart = 0;
    var proCheckMiniCart = setInterval(function () {
      if(retriesMiniCart == 100) {
        console.log("Stopping Retry, Minicart");
        clearInterval(proCheckMiniCart);
      }
      if ($(".csapp-discount-list").length > 0 && $(".yotpo-notif-sidecart").length == 0) {
        $('.csapp_discount_total_wrapper').parent().after(`
          <div class="yotpo-notif-sidecart clearfix margin-x-sm" style="padding: 10px; border: 1px solid #E5E4E2; margin-bottom: 10px; display: flex;">
            <!--<span style="font-size: 30px; float: left; height: 65px; margin-right: 15px; line-height: 28px;">&#9432;</span>-->
            <div style="float: left; flex-grow: 1;"><img style="margin-right: 15px; height: 25px; max-width: fit-content;" src="https://cdn.shopify.com/s/files/1/0658/6335/2559/files/info_icon_dbb3607d-c765-4ed5-ae43-75bdb6829eb3_256x256.png" /></div>
            <p style="">Applying your Tala Pro Discount may slightly delay reward redemption. Please wait up to 1 minute and refresh to redeem both at checkout.</p>
          </div>
        `);
        // $('.csapp-price-saving').hide();
        clearInterval(proCheckMiniCart);
      }
      retriesMiniCart++;
    }, 200); 
  });